import { render, staticRenderFns } from "./LeftSideBar.vue?vue&type=template&id=2a2b60b5&scoped=true&"
import script from "./LeftSideBar.vue?vue&type=script&lang=js&"
export * from "./LeftSideBar.vue?vue&type=script&lang=js&"
import style0 from "./LeftSideBar.vue?vue&type=style&index=0&id=2a2b60b5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2b60b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a2b60b5')) {
      api.createRecord('2a2b60b5', component.options)
    } else {
      api.reload('2a2b60b5', component.options)
    }
    module.hot.accept("./LeftSideBar.vue?vue&type=template&id=2a2b60b5&scoped=true&", function () {
      api.rerender('2a2b60b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LeftSideBar.vue"
export default component.exports